import { MapTo } from '@adobe/aem-react-editable-components';
import ContinueTraining, { ContinueTrainingProps } from './ContinueTraning';
import { WithEmptyPlaceholder } from '../../../../lib/hoc/WithEmptyPlaceholder';
import WithAuth from '../../../../lib/hoc/WithAuth/WithAuth';

const RESOURCE_TYPE = 'learning-academy/components/custom/continuetraining';

const ContinueTrainingEmptyFn = (props: ContinueTrainingProps) => !props.limit && props.isInEditor;

const EditConfig = {
  emptyLabel: 'Continue Training',
  isEmpty: ContinueTrainingEmptyFn,
};

export default MapTo<ContinueTrainingProps>(RESOURCE_TYPE)(
  ...WithEmptyPlaceholder(WithAuth(ContinueTraining), EditConfig),
);
